export const DEFAULT_LIVE_TEXT_SETTINGS = {
  text: 'Welcome to AskTide',
  fontSize: 48,
  margin: 5,
  textColor: '#ffffff',
  backgroundColor: '#1a1a1a',
  verticalPosition: 'middle',
  backgroundOpacity: 100
};

export const clampBackgroundOpacity = (value, fallback = 100) => {
  const parsed = Number(value);
  if (Number.isNaN(parsed)) return fallback;
  return Math.min(100, Math.max(0, Math.round(parsed)));
};

export const hasLiveTextContent = (text) => {
  if (text == null) return false;
  return String(text).trim().length > 0;
};

export const normalizeLiveTextSettings = (settings = {}) => {
  const hasOpacity = settings.backgroundOpacity !== undefined && settings.backgroundOpacity !== null && settings.backgroundOpacity !== '';
  const backgroundOpacity = hasOpacity
    ? clampBackgroundOpacity(settings.backgroundOpacity, 100)
    : (settings.transparentBackground ? 0 : 100);

  return {
    // Keep empty / whitespace strings. `||` would replace them with the welcome default
    // and prevent Send from clearing the overlay.
    text: settings.text !== undefined && settings.text !== null
      ? String(settings.text)
      : DEFAULT_LIVE_TEXT_SETTINGS.text,
    fontSize: settings.fontSize !== undefined ? settings.fontSize : DEFAULT_LIVE_TEXT_SETTINGS.fontSize,
    margin: settings.margin !== undefined ? settings.margin : DEFAULT_LIVE_TEXT_SETTINGS.margin,
    textColor: settings.textColor || DEFAULT_LIVE_TEXT_SETTINGS.textColor,
    backgroundColor: settings.backgroundColor || DEFAULT_LIVE_TEXT_SETTINGS.backgroundColor,
    verticalPosition: settings.verticalPosition || DEFAULT_LIVE_TEXT_SETTINGS.verticalPosition,
    backgroundOpacity
  };
};

export const isTransparentQueryValue = (value) => {
  if (value == null) return false;
  return ['1', 'true', 'yes'].includes(String(value).toLowerCase());
};

export const hexToRgba = (hex, opacityPercent) => {
  const alpha = clampBackgroundOpacity(opacityPercent, 100) / 100;
  if (!hex || typeof hex !== 'string') {
    return `rgba(26, 26, 26, ${alpha})`;
  }

  const cleaned = hex.trim().replace('#', '');
  const full = cleaned.length === 3
    ? cleaned.split('').map((char) => char + char).join('')
    : cleaned;

  if (!/^[0-9a-fA-F]{6}$/.test(full)) {
    return `rgba(26, 26, 26, ${alpha})`;
  }

  const red = parseInt(full.slice(0, 2), 16);
  const green = parseInt(full.slice(2, 4), 16);
  const blue = parseInt(full.slice(4, 6), 16);
  return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
};

export const overlayTextShadow = '0 0 4px rgba(0,0,0,0.95), -1px -1px 0 rgba(0,0,0,0.85), 1px -1px 0 rgba(0,0,0,0.85), -1px 1px 0 rgba(0,0,0,0.85), 1px 1px 0 rgba(0,0,0,0.85), 0 2px 8px rgba(0,0,0,0.75)';
export const defaultTextShadow = '2px 2px 4px rgba(0, 0, 0, 0.5)';
